export default __webpack_public_path__ + "bml-txtbg4fd7f4.png";